import { createRoutine } from "../utils/routine.utils";
export var getSubscription = createRoutine("SUBSCRIPTION_GET");
export var createSubscription = createRoutine("SUBSCRIPTION_CREATE");
export var updateSubscription = createRoutine("SUBSCRIPTION_UPDATE");
export var deleteSubscription = createRoutine("SUBSCRIPTION_DELETE");
export var submitSubscription = createRoutine("SUBSCRIPTION_SUBMIT");
export var markSubscriptionAsPaid = createRoutine("SUBSCRIPTION_MARK_PAID");
export var getSubscriptionsPaged = createRoutine("SUBSCRIPTION_GET_PAGED");
